import { _getCurrentSessionIndex } from '../../js/noteTemplates/sessionsHelper'

export default {
  firestoreReady: false,
  settingsOpen: false,
  settingsSearchTerm: '',
  searchOpen: false,
  searchTerm: '',
  reorderModalOpen: false,
  reorderModalItemId: null,
  distractionFreeMode: false,
  skipMdRender: false,
  offlinePersistenceEnabled: false,
  onlineStatus: true,
  currentSessionIndex: _getCurrentSessionIndex(),
  componentLog: ''
}
